

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Link, browserHistory } from 'react-router';
import ComponentIcons from '../ComponentIcons';
import Modal from '../Modal';
import * as d3 from 'd3';
import styles from './PicturingChoices.css';
import withStyles from '../../decorators/withStyles';
import {SetModalVisible, SetModalTitle} from "../../actions";
import { gaEvent, sameLocationNewHash } from "../../utils/utils";


class PicturingChoices extends Component {

  static propTypes = {
    location: PropTypes.object
  };

  static defaultProps = {
    // url: "//ccimgs-2017.s3.amazonaws.com/2017Lamm/georgetown_stgeorge_4C.jpg"
    location: {url: "/static/img/nassau_cathedral_4C_highres.jpg", name: "Nassau, The Bahamas"}
  };

  constructor(props) {
    super(props);
    this.state = {
      isVertical: false
    };
  }

  openInfo = e => {
    gaEvent('modal', 'open', 'info-picturingchoices');
    browserHistory.push({pathname: "/about", hash: "#about-picturingchoices",
      state: {modal: true, modalTitle: "About this site", returnTo: location.pathname}}
    );
  };

  closeAll = () => {
    this.props.dispatch(SetModalVisible(false));
    this.setState({downloadOpen: false, settingsOpen: false});
  };

  openDownload = e => {
    this.closeAll();
    this.props.dispatch(SetModalVisible(true));
    this.setState({downloadOpen: true})
  };

  closeDownload = e => {
    this.props.dispatch(SetModalVisible(false));
    this.setState({downloadOpen: false});
  };

  setVertical = (width) => {
    if (width < 740) {
      this.setState({isVertical: false});
    } else {
      this.setState({isVertical: true});
    }
  };

  componentDidMount() {
    const self = this;
    self.setVertical(window.innerWidth);
    d3.select(window).on('resize.pc', function() {
      self.setVertical(this.innerWidth);
    });
    // const loadScript = (path, cb) => {
    //   const script = document.createElement("script");
    //   script.src = path;
    //   document.body.appendChild(script);
    //
    //   if (cb) {
    //     script.onload = () => cb(script);
    //   }
    // };
    //
    // loadScript("/static/jquery-1.6.1.min.js", () => {
    //   loadScript("/static/jquery-ui-1.8.13.custom.min.js");
    //   loadScript("/static/jquery.ui.touch-punch.min.js");
    //   loadScript("/static/jquery.beforeafter-1.4-GA.js", () => {
    //     $('#slider-container').beforeAfter({
    //       animateIntro : true,
    //       introDelay : 3000,
    //       introDuration : 1000,
    //       showFullLinks: false,
    //       beforeLinkText : "",
    //       afterLinkText : "",
    //       introPosition : 0.50,  /*how you change where the slider stops*/
    //       // eventName: 'Kingston',
    //       campaignName: 'Lamm-2017-Sliders-SSRF'
    //     });
    //   });
    // });
  }
  // width="720"
  // height="482"

  render() {
    const extLink = (
        <a href="" target="_blank">
          <svg className="externallink icon" style={{fill: "#FFCA3A"}} fill="#FFCA3A" height="22" width="22" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            {/*<path d="M0 0h24v24H0z" fill="none" />*/}
            <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
          </svg>
          <span className="icon" style={{color: "#FFCA3A", marginRight: 0, width: 35}}><span style={{marginTop: 3, display: "inline-block"}}>More</span></span>
        </a>
    );

    return (
        <div className="PicturingChoices">
          <div id="slider-container" className={this.state.isVertical ? "vertical" : ""} style={{padding: 0, margin: "0 auto"}}>
            <div className="text-overlay">
              <section>
                <div className="header">
                  <a className="anchor" id="picturing-choices"/>
                  <Link className="hash-link" to={sameLocationNewHash("#picturing-choices")}>
                    <h1>Picturing Choices: {this.props.location.name}<span className="anchor-hash">#</span></h1>
                  </Link>
                  <ComponentIcons hasDownload={true} openDownload={() => {this.props.dispatch(SetModalTitle("Download images")); this.openDownload()}}
                                  hasSettings={false} openInfo={this.openInfo} extLink={extLink} />
                </div>
              </section>
            </div>
            {/*<div className="caption">
              <h2>{this.props.location.name}</h2>
            </div>
            */}
            <div className="lamm-image">
              <img alt=""
                   src={this.props.location.url.replace("4C", "2C")}
                   id="afterimage54075023" />
            </div>
            <div className="lamm-image">
              <img alt=""
                   src={this.props.location.url}
                   id="beforeimage54075023" />
            </div>

            <div className="label-top">
              <div className="scenario-label label-left two-C"><div>After 2° C Warming</div></div>
            </div>
            <div style={{clear: "both"}}>
              <div className="bottom">
                <div className="scenario-label label-left four-C"><div>After 4° C Warming</div></div>
                <div className="scenario-label label-right two-C"><div>After 2° C Warming</div></div>
              </div>
            </div>
          </div>
          <Modal
              isOpen={this.state.downloadOpen && this.props.modalVisible}
              handleClick={this.closeDownload}
              containerClass="download"
          >
            <p>Downloads are available for these images and other locations
            on <a href="https://www.climatecentral.org/news/american-icons-threatened-by-sea-level-rise-in-pictures-19547" target="_blank">U.S.</a>, <a href="https://www.climatecentral.org/news/sea-level-stakes-for-the-caribbean-in-pictures-21770" target="_blank">Caribbean</a>,
            and <a href="https://www.climatecentral.org/news/global-icons-at-risk-from-sea-level-rise-pictures-19633" target="_blank">global</a> pages.
            </p>
          </Modal>

        </div>
      )
  }

}

const props = state => {return {placeID: state.place.id, placeType: state.place.type}};

export default compose(
  withStyles(styles),
  connect(props),
)(PicturingChoices);
